function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import dateid from '@paperstac/common/lib/services/dateid';
import functions from '@paperstac/firebase/lib/functions';
import storage from '@paperstac/firebase/lib/storage';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Box from '../Box';
import Button from '../Button';
import ExternalLinkIcon from '../icons/ExternalLinkIcon';
import FileInputButton from './FileInputButton';
const onUploadProgress = snapshot => {
  const progress = Math.floor(snapshot.bytesTransferred / snapshot.totalBytes * 100);
  console.log("Upload progress: ".concat(progress, "%"));
};
const onUploadError = error => {
  throw error;
};
const getSignedUrl = functions.httpsCallable('signedUrlForUpload');
const FileUpload = /*#__PURE__*/memo(_ref => {
  let {
    field,
    form,
    name,
    value,
    onChange,
    replaceButtonProps,
    uploadButtonProps,
    uploadPath,
    viewButtonProps,
    ...props
  } = _ref;
  const [isBusy, setIsBusy] = React.useState(false);
  const setBusy = React.useCallback(() => setIsBusy(true), []);
  const setNotBusy = React.useCallback(() => setIsBusy(false), []);
  const viewUrl = value ? value : field.value;
  const handleFiles = files => {
    try {
      setBusy();
      const file = files[0];
      const filePath = "".concat(uploadPath, "/").concat(dateid(), "-").concat(file.name);
      const uploadTask = storage.child(filePath).put(file, {
        cacheControl: 'public,max-age=31536000'
      });
      uploadTask.on('state_changed', onUploadProgress, onUploadError, async () => {
        const result = await getSignedUrl(filePath);
        const evt = {
          target: {
            name: name || field.name,
            value: result.data
          }
        };
        onChange ? onChange(evt) : field.onChange(evt);
        setNotBusy();
        console.log('Upload complete');
      });
    } catch (error) {
      setNotBusy();
      alert(error.message);
    }
  };
  return !viewUrl ? /*#__PURE__*/React.createElement(Box, _extends({
    mt: 2
  }, props), /*#__PURE__*/React.createElement(FileInputButton, _extends({
    name: name || field.name,
    onFiles: handleFiles,
    multiple: false,
    isBusy: isBusy,
    children: "Upload"
  }, uploadButtonProps)), ' ') : /*#__PURE__*/React.createElement(Box, _extends({
    mt: 2
  }, props), /*#__PURE__*/React.createElement(FileInputButton, _extends({
    name: name || field.name,
    onFiles: handleFiles,
    multiple: false,
    isBusy: isBusy,
    mr: 2,
    children: "Replace"
  }, replaceButtonProps)), /*#__PURE__*/React.createElement(Button, _extends({
    as: "a",
    target: "_blank",
    href: viewUrl,
    children: /*#__PURE__*/React.createElement(React.Fragment, null, "View", ' ', /*#__PURE__*/React.createElement(ExternalLinkIcon, {
      style: {
        position: 'relative',
        top: '-2px'
      }
    }))
  }, viewButtonProps)));
});
FileUpload.propTypes = {
  ...Box.propTypes,
  uploadPath: PropTypes.string.isRequired,
  uploadButtonProps: PropTypes.object,
  replaceButtonProps: PropTypes.object,
  viewButtonProps: PropTypes.object
};
FileUpload.defaultProps = {
  uploadButtonProps: {
    variant: 'secondary'
  },
  replaceButtonProps: {
    variant: 'redOutline'
  },
  viewButtonProps: {
    variant: 'secondaryOutline'
  }
};
FileUpload.displayName = 'FileUpload';
export default FileUpload;